import { mapGetters } from 'vuex'
import { resolveSubuserPermissionSlug } from '@/utils/subuser-permissions'

export default {
  computed: {
    ...mapGetters({
      primaryAccount: 'permissions/isPrimaryAccount',
      currentBranchId: 'branches/currentBranchId',
      isDark: 'appConfig/isDark',
      isRTL: 'appConfig/isRTL',
      hasSubuserPermission: 'permissions/hasSubuserPermission',
      hasAnySubuserPermission: 'permissions/hasAnySubuserPermission',
      hasAllSubuserPermissions: 'permissions/hasAllSubuserPermissions',
    }),
  },
  methods: {
    hasPermission(permission) {
      return this.hasSubuserPermission(permission)
    },
    canView(actionOrSlug, subject) {
      if (this.primaryAccount) return true

      if (!subject && typeof actionOrSlug === 'string' && actionOrSlug.includes('.')) {
        return this.hasSubuserPermission(actionOrSlug)
      }

      const slug = resolveSubuserPermissionSlug(actionOrSlug, subject)
      if (!slug) return false
      return this.hasSubuserPermission(slug)
    },
  },
}
